import customerIncompleteHandler from '@/mixins/customerIncompleteHandler'

export default {
  mixins: [customerIncompleteHandler],
  methods: {
    handleErrorMessage (data) {
      if (data.errors && data.errors.length) {
        if (data.errors[0].type === 'MtmSecurityCodeError') {
          this.$root.$emit('enter-security-code')
        } else if (data.errors[0].type === 'MtmCustomerInfoUpdateNotCompleteError') {
          this.handleIncompleteCustomer()
        } else {
          this.toast('error', {
            message: data.errors[0].message || this.$t('errors.defaultError')
          })
        }
      } else {
        this.toast('error', {
          message: this.$t('errors.serverError')
        })
      }
    }
  }
}
